<template>
  <TransitionRoot as="template" :show="open">
      <Dialog class="relative z-50" @close="closeDialog">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
              <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>

          <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                      <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-8 pb-8 pt-6 text-left shadow-xl transition-all sm:my-8 sm:w-full lg:max-w-2xl sm:p-6">
                          <!-- Título e botão de fechar -->
                          <div class="flex justify-between items-start mb-6">
                              <h2 class="text-xl font-bold leading-9 tracking-tight text-gray-900">Upload de Matrizes do Plano</h2>
                              <button @click="closeDialog" type="button" class="text-gray-400 hover:text-gray-600">
                                  <span class="sr-only">Fechar</span>
                                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                  </svg>
                              </button>
                          </div>

                          <div class="space-y-6">
                          <div class="space-y-6">
                              <!-- Matriz de Reenquadramentos -->
                              <div class="border border-gray-200 rounded-lg p-4 bg-gray-50">
                                  <h3 class="text-lg font-medium text-gray-900 mb-2">Matriz de Reenquadramento</h3>
                                  <p class="text-sm text-gray-500 mb-2">Envie o arquivo CSV (separado por ponto e vírgula) contendo as regras de reenquadramento de limites de capital para este plano.</p>
                                  <div class="bg-blue-50 border border-blue-100 rounded p-2 mb-4">
                                    <p class="text-xs font-semibold text-blue-800 mb-1">⚠️ Colunas obrigatórias no cabeçalho do CSV:</p>
                                    <code class="text-xs text-blue-700 bg-white px-1 py-0.5 rounded border border-blue-200 block overflow-x-auto whitespace-nowrap"><span class="font-bold">capital_minimo</span> ; <span class="font-bold">capital_maximo</span> ; <span class="font-bold">ate_24_anos</span> ; <span class="font-bold">25_a_30_anos</span> ; <span class="font-bold">31_a_35_anos</span> ; <span class="font-bold">36_a_40_anos</span> ; <span class="font-bold">41_a_45_anos</span> ; <span class="font-bold">46_a_50_anos</span> ; <span class="font-bold">51_a_55_anos</span> ; <span class="font-bold">56_a_60_anos</span> ; <span class="font-bold">61_a_65_anos</span> ; <span class="font-bold">mais_65_anos</span></code>
                                  </div>
                                  
                                  <div class="mt-2">
                                      <input type="file" @change="onFileReenqChange" id="file_reenq" accept=".csv" class="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-white focus:outline-none file:mr-4 file:py-2 file:px-4 file:rounded-l-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" />
                                      <span v-if="fileReenqError" class="text-red-500 text-xs mt-1 block">{{ fileReenqError }}</span>
                                  </div>
                                  
                                  <div class="mt-4 flex justify-end">
                                      <button @click="uploadMatrizReenquadramentos" :disabled="!fileReenq || loadingReenq" class="inline-flex justify-center items-center rounded-md border border-transparent bg-blue-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed">
                                          <svg v-if="loadingReenq" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                                          {{ loadingReenq ? 'Enviando...' : 'Enviar Matriz de Reenq.' }}
                                      </button>
                                  </div>
                              </div>
                          </div>
                          </div>

                      </DialogPanel>
                  </TransitionChild>
              </div>
          </div>
      </Dialog>
  </TransitionRoot>
</template>

<script>
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';
import PlanoMatrizRepository from '@/services/PlanoMatrizRepository.vue';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import Swal from 'sweetalert2';

export default {
  name: 'MatrizesUploadModal',
  props: {
      open: {
          type: Boolean,
          required: true
      },
      planoId: {
          type: [Number, String],
          required: true
      }
  },  
  data() {
      return {
          fileReenq: null,
          fileReenqError: '',
          loadingReenq: false,
          onlineUser: JSON.parse(window.localStorage.getItem("myUser"))
      };
  },
  methods: {
      onFileReenqChange(event) {
          const file = event.target.files[0];
          this.validateFile(file, 'fileReenq', 'fileReenqError');
      },
      validateFile(file, fileVar, errorVar) {
          if (file) {
              if (file.size > 15 * 1024 * 1024) { // 15 MB
                  this[errorVar] = 'O arquivo deve ter no máximo 15MB.';
                  this[fileVar] = null;
              } else if (file.type !== 'text/csv' && !file.name.endsWith('.csv')) {
                  this[errorVar] = 'O arquivo deve ser obrigatoriamente um CSV.';
                  this[fileVar] = null;
              } else {
                  this[errorVar] = '';
                  this[fileVar] = file;
              }
          }
      },
      async uploadMatrizReenquadramentos() {
          if (!this.fileReenq || !this.planoId) return;
          
          this.loadingReenq = true;
          const formData = new FormData();
          formData.append('file', this.fileReenq);
          formData.append('plano_id', this.planoId);
          
          const repo = new PlanoMatrizRepository();
          try {
              const url = process.env.VUE_APP_API_URL + 'planos/matriz-reenquadramentos/upload';
              const response = await repo.uploadReenquadramentos(url, formData, this.onlineUser.token);
              if (response?.status === 200 || response?.status === 202) {
                  this.mostrarAlertaSucesso('Matriz de Reenquadramentos colocada em fila para processamento.');
                  this.fileReenq = null;
                  document.getElementById('file_reenq').value = ''; // Limpa o input
              } else {
                  this.mostrarAlertaErro(response?.data?.message || 'Erro ao enviar matriz.');
              }
          } catch (error) {
              handleUnauthorized(error);
              this.mostrarAlertaErro('Erro na conexão ao enviar Matriz de Reenquadramentos.');
          } finally {
              this.loadingReenq = false;
          }
      },
      mostrarAlertaSucesso(msg) {
          Swal.fire({
              icon: 'success',
              title: 'Upload Enviado!',
              text: msg,
              confirmButtonColor: '#3085d6',
          });
      },
      mostrarAlertaErro(msg) {
          Swal.fire({
              icon: 'error',
              title: 'Ops...',
              text: msg,
              confirmButtonColor: '#3085d6',
          });
      },
      closeDialog() {
          this.$emit('update-open', false);
          // Opcional: Limpar campos ao fechar
          this.fileReenq = null;
          this.fileReenqError = '';
      },
  },
  components: {
      Dialog,
      DialogPanel, 
      TransitionChild, 
      TransitionRoot
  },
}
</script>
